module.exports = __webpack_public_path__ + "static/baked_brownie-84765d8d25d1b3312c73a643fab7b5e1.jpg";